import { useEffect, useState } from "react";
import { useGlobalYear } from "@/lib/useGlobalYear";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CURRENT_YEAR, YEARS, MONTHS, IMP_STATUS } from "@/lib/constants";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ImpBadge, PageHeader } from "@/components/Badges";
import { OreoEmpty } from "@/components/Oreo";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

export default function ImprovementList() {
  const [items, setItems] = useState([]);
  const [tab, setTab] = useState("all");
  const [year, setYear] = useGlobalYear();
  useEffect(() => { api.get(`/improvements?year=${year}`).then((r) => setItems(r.data)); }, [year]);
  const rows = tab === "all" ? items : items.filter((i) => i.status === tab);
  const counts = Object.keys(IMP_STATUS).reduce((a, k) => ({ ...a, [k]: items.filter((i) => i.status === k).length }), {});
  return (
    <div data-testid="improvement-list-page">
      <PageHeader title="Improvement Sheet (Kaizen)" subtitle="Dibuat otomatis saat KPI Not Achieve. Alur: Draft → Submitted → Review atasan → Approved / Revisi">
        <Select value={year} onValueChange={setYear}><SelectTrigger data-testid="imp-year-select" className="w-28 bg-white"><SelectValue /></SelectTrigger><SelectContent>{YEARS.map((y) => <SelectItem key={y} value={String(y)}>{y}</SelectItem>)}</SelectContent></Select>
      </PageHeader>
      <Tabs value={tab} onValueChange={setTab} className="mb-3"><TabsList className="flex-wrap h-auto">
        <TabsTrigger value="all" data-testid="imp-tab-all">Semua ({items.length})</TabsTrigger>
        {Object.entries(IMP_STATUS).map(([k, v]) => <TabsTrigger key={k} value={k} data-testid={`imp-tab-${k}`}>{v.label} ({counts[k]})</TabsTrigger>)}
      </TabsList></Tabs>
      <div className="card-flat overflow-x-auto">
        <table className="w-full dense-table" data-testid="improvement-table">
          <thead><tr><th>KPI</th><th>Bulan</th><th>Pemicu</th><th>PIC</th><th>Status</th><th>Problem</th><th>Update</th><th></th></tr></thead>
          <tbody>
            {rows.map((i) => (
              <tr key={i.id} data-testid={`imp-row-${i.id}`}>
                <td className="font-medium">{i.kpi_code} · {i.kpi_name}</td><td>{MONTHS[i.month - 1]}{(i.months_covered || []).length > 1 && <span className="text-slate-500">–{MONTHS[Math.max(...i.months_covered) - 1]}</span>} {i.year}</td><td className="text-xs">{i.trigger_reason}</td><td className="text-xs">{i.pic_name}</td>
                <td><ImpBadge status={i.status} /></td><td className="text-xs text-slate-500 max-w-xs truncate">{i.problem || <em>belum diisi</em>}</td>
                <td className="text-xs text-slate-400">{new Date(i.updated_at).toLocaleDateString("id-ID")}</td>
                <td><Link to={`/improvement/${i.id}`} data-testid={`imp-open-${i.id}`} className="text-xs text-blue-700 hover:underline">Buka</Link></td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={8}><OreoEmpty mood="bagus" text="Tidak ada improvement — semua KPI aman!" testId="improvement-empty" /></td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
